export default __webpack_public_path__ + "static/media/T30.33b0fdb9.JPG";